require('jquery-touchswipe');

$(function() {
  $("#brochureSliderWithArrows").swipe( {
    //Generic swipe handler for all directions
    swipe:function(event, direction, distance, duration, fingerCount, fingerData) {
      if (direction == 'right') {
        //swipe left
        $("#brochureSliderWithArrows").carousel('prev');
      } else {
        //swipe right
        $("#brochureSliderWithArrows").carousel('next');
      }
    }
  });
});